import CityPageTemplate from "@/pages/hawaii-city/CityPageTemplate";
import { wailukuConfig } from "./data";

export default function WailukuPage() {
  return <CityPageTemplate config={wailukuConfig} />;
}